import { render, staticRenderFns } from "./item.vue?vue&type=template&id=070be53d&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
import style0 from "./aside.scss?vue&type=style&index=0&id=070be53d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070be53d",
  null
  
)

export default component.exports